import type { EventLog } from '../generated/models/event-log';
import type { EventEntry, EventLogResponse } from '../../models/event-log.model';
import { extractStatusMessage } from './adapter.utils';

/**
 * Maps the `POST /process-server/{serverId}/eventlog/add` response.
 *
 * @remarks
 * Live API returns `{ "status": "success", "message": "Event logged successfully" }`.
 *
 * @param raw - Untyped API response.
 */
export function eventLogToModel(raw: unknown): EventLogResponse {
  return extractStatusMessage(raw);
}

/**
 * Builds the request body for
 * `POST /process-server/{serverId}/eventlog/add`.
 *
 * @param entries - Array of event entries to submit.
 */
export function toPayload(entries: EventEntry[]): EventLog {
  return {
    event: entries.map((e) => ({
      job_id: e.jobId,
      action: e.action,
      message: e.message,
      appver: e.appVersion,
      device_id: e.deviceId,
      device_platform: e.devicePlatform,
      coords_latitude: e.latitude,
      coords_longitude: e.longitude,
      ip_address: e.ipAddress,
      timestamp: e.timestamp,
    })),
  };
}
